import { ArticleParagraph1, Col, Row, UIHeading1, UIHeading2, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { IRosreestrInfo } from '../../types/offerData';
import { CollapseButton } from '../CollapseButton';
import * as styles from './styles.css';

export interface IRosreestrInfoNewProps extends IRosreestrInfo {
  isSinglePart: boolean;
  onOpen(): void;
  showOpenButton: boolean;
}

export const RosreestrInfoNew: React.VFC<IRosreestrInfoNewProps> = ({
  header,
  deck,
  parts,
  bottom,
  isSinglePart,
  onOpen,
  showOpenButton,
}) => {
  return (
    <div>
      <div className={styles['header']}>
        <UIHeading1 color="black_100">{header}</UIHeading1>
        <UIText2>{deck}</UIText2>
      </div>

      <Row>
        {parts.map(({ header: subHeader, elements }) => (
          <Col key={subHeader} l={isSinglePart ? 12 : 6} xs={12}>
            <div className={styles['sub-header']}>
              <UIHeading2>{subHeader}</UIHeading2>
            </div>

            {elements.map(({ title, value }) => (
              <div key={title} className={styles['part']}>
                <div className={styles['item']}>
                  <ArticleParagraph1 color="gray60_100">{title}</ArticleParagraph1>
                </div>

                <div className={styles['item']}>
                  <ArticleParagraph1 color="black_100">{value}</ArticleParagraph1>
                </div>
              </div>
            ))}
          </Col>
        ))}
      </Row>

      {bottom && (
        <div className={styles['bottom']}>
          <UIText2 color="gray60_100">{bottom}</UIText2>
        </div>
      )}

      {showOpenButton && (
        <div className={styles['collapse-button']}>
          <CollapseButton onClick={onOpen} isCollapsed collapsedText="Читать дальше" />
        </div>
      )}
    </div>
  );
};
